$(function() {
    //Get the elements for later use
    var $mailForm = $('#contactForm');

    $mailForm.each(function(index, element) {
        var $form = $(element);

        $form.validate({
            errorPlacement: function(error, element) {
                if (element.hasClass('form-checkbox')) {
                    var label = $("label[for='" + element.attr('id') + "']");
                    if (label.length <= 0) {
                        error.insertAfter(element);
                    } else {
                        error.insertAfter(label);
                    }
                } else {
                    error.insertAfter(element);
                }
            },
            rules: {
                phone: { phone: true },
                houseNumber: { greaterThanZero: true },
                units: { integerGreaterThanZero: true },
                zipCode: { zipcode: true },
            },
        });

        $form.find('.btn').on('click', function(e) {
            e.preventDefault();
            var enctype = $form.attr('enctype');
            var $alertBox = $form.find('.alert');

            if ($form.valid()) {
                $form.addClass('processing');

                var successCallback = function() {
                    $form.removeClass('processing');

                    showAlert($alertBox.data('title-success'), '', false, $form);
                    $('.contact-form-component')
                        .find('.form-wrapper')
                        .remove();
                };

                var failCallback = function() {
                    $form.removeClass('processing');
                    showAlert($alertBox.data('title-error'), '', true, $form);
                };

                var arr = $form.serializeArray();
                var obj = objectifyForm(arr);
                var json = JSON.stringify(obj);

                $.ajax({
                    type: 'POST',
                    url: $form.attr('action'),
                    data: json,
                    dataType: 'json',
                    contentType: 'application/json',
                    success: successCallback,
                    error: failCallback,
                });
            } else {
                $form.removeClass('processing');
                // Scroll to first error in form
                $('html, body').animate(
                    {
                        scrollTop: $('select.error, input.error, textarea.error').offset().top - 30,
                    },
                    'fast'
                );
            }
        });
    });

    function showAlert(title, message, error, form) {
        var color = 'green';
        var alertBox = form.find('.alert');

        if (error) {
            alertBox.addClass('error');
            color = 'red';
        } else {
            alertBox.addClass('success');
        }
        var html = '<p class="' + color + ' text-center">' + title + '</p>' + message;
        alertBox.html(html);
        alertBox.show();

        $('html, body').animate({ scrollTop: $('.contact-form-component').offset().top }, 'fast');
    }
});
